export default {
    current_choice: 'Huidige keuze',
    book_now: 'Nu boeken',
    minimum_age: 'Alleen ouder dan {age}',
    excess_liability: 'Eigen risico',
    security_deposit: 'Borgsom',
    fuel_policy: 'Brandstofbeleid',
    like_for_like: 'Zelfde peil terug',
    full_to_full: 'Vol terug',
    miles_per_rental: '{mileage} gratis kilometers per boeking',
    km_per_rental: '{mileage} gratis km per boeking',
    unlimited_mileage: 'Onbeperkte kilometers',
    unlimited_mileage_km: 'Onbeperkte km',
    non_amendable: 'Niet wijzigbaar',
    non_refundable: 'Niet restitueerbaar',
    free_cancellation_until: 'Gratis te annuleren tot',
    cancellation_in_line_with: 'Annulering overeenkomstig de',
    tcs: 'Voorwaarden',
    free_extras_on_collection: 'Twee gratis extra\'s bij ophalen',
    glass_and_tyres_covered: 'Ruiten en banden gedekt',
    number_of_passengers: 'Aantal passagiers',
    number_of_bags: 'Aantal tassen',
    fuel_type: 'Brandstoftype',
    co2: 'CO2',
    aircon: 'Airco',
    transmission: 'Versnelling',
    book_type: '{type} boeken',
    debit_card_deposit: 'Betaalpas geaccepteerd voor stortingen',
    fast_track_included: 'Inclusief snelle track',
}
